import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import adminRoutes from './admin.routes'
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'landing',
      component: () => import('@/components/Marketing/LandingPage.vue'),
      meta: {
        title: '',
        layout: 'marketing'
      }
    },
    {
      path: '/changelog',
      name: 'changelog',
      component: () => import('@/components/Marketing/Changelog.vue'),
      meta: {
        title: 'Changelog',
        layout: 'marketing'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/components/Marketing/AboutPage.vue'),
      meta: {
        title: 'À propos',
        layout: 'marketing'
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('@/components/Marketing/FAQPage.vue'),
      meta: {
        title: 'FAQ',
        layout: 'marketing'
      }
    },
    {
      path: '/app',
      name: 'home',
      component: () => import('@/components/Dashboard/Dashboard.vue'),
      meta: {
        requiresAuth: true,
        title: 'Dashboard'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/auth/LoginForm.vue'),
      meta: {
        title: 'Connexion',
        layout: 'auth'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/components/auth/Register.vue'),
      meta: {
        title: "Inscription",
        layout: 'auth'
      }
    },
    {
      path: '/activation-sent',
      name: 'activation-sent',
      component: () => import('@/components/auth/ActivationSent.vue'),
      meta: {
        title: 'Vérifiez votre email',
        layout: 'auth'
      }
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/components/auth/ForgotPassword.vue'),
      meta: {
        title: 'Mot de passe oublié',
        layout: 'auth'
      }
    },
    {
      path: '/resend-activation',
      name: 'resend-activation',
      component: () => import('@/components/auth/ResendActivation.vue'),
      meta: {
        title: "Renvoyer l'activation",
        layout: 'auth'
      }
    },
    {
      path: '/reset-password/:uid/:token',
      name: 'reset-password',
      component: () => import('@/components/auth/ResetPassword.vue'),
      meta: {
        title: 'Réinitialisation du mot de passe',
        layout: 'auth'
      }
    },
    {
      path: '/portfolio',
      name: 'portfolio',
      component: () => import('@/components/Portfolio/Portfolio.vue'),
      meta: {
        requiresAuth: true,
        title: 'Mon portefeuille'
      }
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: () => import('@/components/Transaction/TransactionView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Transactions'
      }
    },
    {
      path: '/dividends',
      name: 'dividends',
      component: () => import('@/components/Dividend/DividendManager.vue'),
      meta: {
        requiresAuth: true,
        title: 'Dividendes'
      }
    },
    // Route des mentions légales supprimée car implémentée comme modal dans Footer.vue
    ...adminRoutes,
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})
// Navigation guard
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  // Initialize auth only once (idempotent)
  if (!authStore.hasInitialized) {
    authStore.initializeAuth()
  }
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  // Set page title safely
  const baseTitle = 'Portfolio Manager'
  const routeTitle = (to.meta?.title as string) || baseTitle
  document.title = to.path === '/' ? baseTitle : `${routeTitle} - ${baseTitle}`
  // Redirects
  if (to.name === 'login' && authStore.isAuthenticated) {
    return next('/app')
  }
  // Si l'utilisateur est authentifié et tente d'accéder à la landing '/', rediriger vers l'app
  if (to.path === '/' && authStore.isAuthenticated) {
    return next('/app')
  }
  // Si l'utilisateur n'est pas authentifié et tente d'accéder à une route protégée, rediriger vers login
  if (requiresAuth && !authStore.isAuthenticated) {
    return next('/login')
  }
  if (requiresAdmin && !authStore.isAdmin) {
    return next('/')
  }
  next()
})
router.afterEach(() => {
  // Navigation terminée
})
export default router
